const NoImage = () => {
	return (
        <img src={require('assets/images/placeholder.png')} alt="нет фото" title="нет фото" itemProp="image"/>
    )
};
export default NoImage;